module.exports = __webpack_public_path__ + "img/about-min.b98786ae.jpg";